// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"327":"1280e1ee","453":"2a254305","702":"c5e0e581"}[chunkId] + ".chunk.js";
};